<template>
  <div class="settingsMenu">
    <div class="settingsMenu__title">Settings</div>
    <div class="settingsMenu__separator"></div>
    <div
      v-for="tab in tabs"
      :key="tab.name"
      :class="[currentTab?.name === tab.name ? 'settingsMenu__item--active' : '', 'settingsMenu__item']"
      @click="setTab(tab)"
    >
      <div class="settingsMenu__item__text">
        {{ tab.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { SettingsStore } from "../ELYXStore";
import SettingsConstants from "./SettingsConstants";
import SettingsMethods from "./SettingsMethods";

export default {
  computed: {
    currentTab: () => SettingsStore.state.currentTab,
    tabs: () => SettingsConstants.tabs,
  },
  methods: {
    setTab: SettingsMethods.setTab,
  },
};
</script>

<style scoped>
.settingsMenu {
  margin-top: 2px;
  padding: 15px;
  box-sizing: border-box;
  width: 250px;
}
.settingsMenu__title {
  padding: 0px 0px;
  margin-left: 8px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  color: #777;
  margin-right: -50px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.settingsMenu__separator {
  border-bottom: 1px solid #cfcfcfa3;
  margin-bottom: 7px;
  margin-top: 7px;
  display: none;
}
.settingsMenu__item {
  width: 220px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  margin: 4px 0px;
  display: block;
  box-sizing: border-box;
  border: none;
}
.settingsMenu__item:hover,
.settingsMenu__item--active {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 4%), 0 2px 4px rgb(15 15 15 / 7%), 0 4px 8px rgb(213 213 213 / 15%);
  background-color: rgba(255, 255, 255, 0.8) !important;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.settingsMenu__item__text {
  color: #333;
  font-size: 16px;
  text-align: left;
  font-weight: 500;
}
@media (max-width: 749px) {
  .settingsMenu {
    width: 100%;
  }
  .settingsMenu__title {
    margin-left: 10px;
    font-size: 14px;
  }
  .settingsMenu__item {
    width: 100%;
    padding: 15px 10px;
  }
  .settingsMenu__item__text {
    font-size: 17px;
  }
  .settingsMenu__separator {
    display: none;
  }
}
</style>
